/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360EntitiesRetailerApiVisitsAnalyticsFilter {
    /**
     * 0 = Gender, 1 = Age, 2 = Interests
     */
    Group?: Open360EntitiesRetailerApiVisitsAnalyticsFilter.GroupEnum;
    StartDate?: Date;
    EndDate?: Date;
    /**
     * 0 = Day, 1 = Week, 2 = Month
     */
    Breakdown?: Open360EntitiesRetailerApiVisitsAnalyticsFilter.BreakdownEnum;
}
export namespace Open360EntitiesRetailerApiVisitsAnalyticsFilter {
    export type GroupEnum = 0 | 1 | 2;
    export const GroupEnum = {
        NUMBER_0: 0 as GroupEnum,
        NUMBER_1: 1 as GroupEnum,
        NUMBER_2: 2 as GroupEnum
    }
    export type BreakdownEnum = 0 | 1 | 2;
    export const BreakdownEnum = {
        NUMBER_0: 0 as BreakdownEnum,
        NUMBER_1: 1 as BreakdownEnum,
        NUMBER_2: 2 as BreakdownEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiVisitsAnalyticsFilter.ts